import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import ModalContext from './ModalContext.js';

function ModalProvider({ children, current, overflow, maxHeight, dragging, onMouseDown, }) {
    const modalContext = useMemo(() => ({
        overflow, maxHeight, dragging, onMouseDown, current,
    }), [current, dragging, maxHeight, onMouseDown, overflow]);
    return (jsx(ModalContext.Provider, { value: modalContext, children: children }));
}

export { ModalProvider as default };
